import type {Identified} from 'typings/portaro.be.types';
import type {UIcons} from 'shared/ui-widgets/uicons/types';
import type {SvelteComponentConstructor} from 'core/types';

export const TABS_CONTEXT_NAME = 'headlessui-tabs-context';

export interface HeadlessTabsApiData {
    tabs: HTMLElement[];
    selectedIndex: number;
    setSelectedIndex: (value: number) => void;
}

export type TabId = `tab-${string}`;
export type TabPanelId = `tab-panel-${string}`;

export interface TabButton extends Identified<TabId> {
    label: string;
    icon: UIcons;
    disabled?: boolean;
    tabPageWithoutPadding?: boolean;
    tabPageContainerClass?: string;
    additionalContentComponent?: {
        component: SvelteComponentConstructor,
        props: Record<string, any>
    };
}